import React, { useState } from 'react';
import { Typography } from 'antd';
import EventLocationPickerModal from '../EventLocationPickerModal';
import { formatLocationValue, isLocationValue } from './locationValue';

/**
 * A place picked on a map, captured in the same modal the inspection-to-event conversion
 * uses. The link shows the chosen address, or "Pick a location" when there is none.
 *
 * The modal speaks latitude/longitude while the answer is stored as lat/lng, so the two
 * are mapped here rather than changing a modal that already works elsewhere.
 */
const LocationPickerField = ({ value, onChange, disabled = false }) => {
  const [open, setOpen] = useState(false);
  const picked = isLocationValue(value);

  return (
    <>
      <Typography.Link disabled={disabled} onClick={() => setOpen(true)}>
        {picked ? 'Change location' : 'Choose location'}
      </Typography.Link>

      {picked && (
        <Typography.Text type="secondary" style={{ display: 'block', marginTop: 6 }}>
          {formatLocationValue(value)}
        </Typography.Text>
      )}

      <EventLocationPickerModal
        open={open}
        onClose={() => setOpen(false)}
        initial={
          picked
            ? { latitude: value.lat, longitude: value.lng, address: value.address }
            : undefined
        }
        onSave={({ latitude, longitude, address }) => {
          onChange?.({ lat: latitude, lng: longitude, address: address ?? '' });
          setOpen(false);
        }}
      />
    </>
  );
};

export default LocationPickerField;
